import React from 'react';
import { Flex, Avatar, DropdownMenu, Badge } from "@radix-ui/themes";
import { useStore } from '../store/store';
import { useNavigate } from 'react-router-dom';
import UpgradeModal from '../components/UpgradeModal';
import Icon from '@mdi/react';
import { mdiAccount } from '@mdi/js';

export const Header = () => {
    const [state, actions] = useStore();
    const [isUpgradeModalOpen, setIsUpgradeModalOpen] = React.useState(false);
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('user');
        actions.setUser(null);
        navigate('/');
    }

    const handleOpenUpgradeModal = () => {
        setIsUpgradeModalOpen(true);
      };
      
      const handleCloseUpgradeModal = () => {
        setIsUpgradeModalOpen(false);
      };

  const subscribeButton = () => {
    return (
      <button className="upgrade-button" onClick={handleOpenUpgradeModal}>
        Subscribe Now
      </button>
    );
  };

    // Calculate trial status and days remaining
  const renderTrialStatus = () => {

    const user = state.user;

    if (!user) return null;
    
    if (user.subscription_active) {
      return (
        <div className="subscription-status active">
          <span>Premium Subscription</span>
        </div>
      );
    }
    
    // Check if trial_end_date exists
    if (user.trial_end_date) {
      const now = new Date().getTime();
      const trialEnd = parseInt(user.trial_end_date, 10);
      const daysRemaining = Math.ceil((trialEnd - now) / (1000 * 60 * 60 * 24));
      
      if (daysRemaining > 0) {
        return (
          <div style={{display: 'flex', alignItems: 'center'}}>
            <div className="subscription-status trial">
              <span onClick={handleOpenUpgradeModal}>Trial: {daysRemaining} {daysRemaining === 1 ? 'day' : 'days'} remaining</span>
            </div>
            {subscribeButton()}
          </div>
        );
      } else {
        return (
          <div style={{display: 'flex', alignItems: 'center'}}>
            <div  style={{
              fontSize: '14px',
              background: 'none',
              border: 'none',
              color: '#cce5ff',
              fontWweight: 'bold',
              cursor: 'pointer'
            }} onClick={handleOpenUpgradeModal} className="subscription-status expired">
              <span>Trial expired (Read Only access) - Subscribe Now</span>
            </div>
          </div>
        );
      }
    }
    
    return (
      <div className="subscription-status unknown">
        <span>Trial status unknown</span>
      </div>
    );
  };

    return (
        <header style={{ padding: '15px 20px'}}>
          {state.user &&
            <Flex justify="end" gap={'50px'}>
                <div>
                    <DropdownMenu.Root>
                        <DropdownMenu.Trigger>
                            <div className="avatar">
                              <Icon path={mdiAccount} size={2} />
                            </div>
                        </DropdownMenu.Trigger>
                        <DropdownMenu.Content sideOffset={5} variant='soft'>
                            <DropdownMenu.Group>
                                <DropdownMenu.Label>{state?.user?.email}</DropdownMenu.Label>
                                <DropdownMenu.Item onSelect={() => navigate('/settings/model')}>Model Settings</DropdownMenu.Item>
                                <DropdownMenu.Item onSelect={() => navigate('/settings/account')}>Account Settings</DropdownMenu.Item>
                                <DropdownMenu.Item onSelect={() => handleLogout()}>Logout</DropdownMenu.Item>
                            </DropdownMenu.Group>
                        </DropdownMenu.Content>
                    </DropdownMenu.Root>
                </div>
            </Flex>
            }
            {/* Upgrade Modal */}
            <UpgradeModal 
                isOpen={isUpgradeModalOpen} 
                onClose={handleCloseUpgradeModal} 
            />
        </header>
    );
};

export default Header;